import { styled } from '@mui/material/styles';

export const CalendarWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.background.default,
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  '& .fc-daygrid-day-top': {
    background: theme.palette.background.paper,
    color: theme.palette.text.secondary,
  },
  '& .fc-daygrid-day': {
    borderColor: theme.palette.divider,
  },
  '& .fc-event': {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.dark,
    borderRadius: theme.shape.borderRadius,
    padding: '2px 4px',
  },
  '& .fc-today': {
    background: theme.palette.secondary.light,
    borderColor: theme.palette.secondary.main,
  },
  '& .fc-header-toolbar': {
    background: theme.palette.background.paper,
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  '& .fc-button': {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
  '& .fc-timegrid-slot': {
    borderColor: theme.palette.divider,
  },
}));
